import { render, staticRenderFns } from "./OtcExposureDrilldown.vue?vue&type=template&id=5f2b5a7a&"
import script from "./OtcExposureDrilldown.vue?vue&type=script&lang=js&"
export * from "./OtcExposureDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports